import { theme } from '@/styles/theme';

export const styles = {
  locationList: {
    width: '100%',
    overflowY: 'auto',
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    paddingTop: 2,
    paddingBottom: 2,
  },
  item: {
    borderRadius: 2,
    border: '1px solid',
    marginBottom: 2,
    cursor: 'pointer',
    gap: 2,
  },
  itemFocused: {
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.light,
      borderColor: theme.palette.primary.main,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  itemNotFocused: {
    borderColor: theme.palette.opaqueGray.main,
  },
  titleCard: {
    fontSize: '14px',
  },
  subtitleCard: {
    color: theme.palette.gray.main,
    fontSize: '14px',
  },
  iconContainer: {
    backgroundColor: 'white',
    boxShadow: 3,
  },
};
